import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    current_header_step: "START",
};

export const smartDeviceFormSlice = createSlice({
    name: "smart_device_form_slice",
    initialState,
    reducers: {
        setSmartDeviceFormData: (state, action) => {
            let { form_name, data } = action.payload || {};
            state[form_name] = data;
        },
        clearSmartDeviceFormData: (state, action) => {
            const { form_name } = action.payload || {};
            if (form_name) {
                state[form_name] = null;
            }
        },

        // header step
        setSmartDeviceFormHeaderStep: (state, action) => {
            let stepType = action.payload;
            state.current_header_step = stepType;
        },

        clearNewSmartDeviceFormData: () => initialState

    }
});

// SELECTORS
export const selectSmartDeviceForm = (store) => store?.smartDeviceFormData;
export const selectSmartDeviceFormHeaderStep = (store) => store?.smartDeviceFormData?.current_header_step;

// ACTIONS
export const {
    setSmartDeviceFormData,
    clearSmartDeviceFormData,
    setSmartDeviceFormHeaderStep,
    clearNewSmartDeviceFormData
} = smartDeviceFormSlice.actions;

export default smartDeviceFormSlice.reducer;
